// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3l6DL","text":"SelectPayment_text__3grXs","title":"SelectPayment_title__1IjoL","btn":"SelectPayment_btn__1iH7r"};